import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { AUTHENTICATION_TYPES } from "../constants";
import { GET_ACCESS_TOKEN_END_POINT_PREFIX } from "../constants/api.constants";
import "./Home.css";

const Home = () => {
  useEffect(() => {
    const fetchAccessTokenAndRedirect = async ({
      authentication_type,
      code,
      fromPage,
      jobNumber,
    }) => {
      try {
        const response = await fetch(
          `${GET_ACCESS_TOKEN_END_POINT_PREFIX}/login?type=${authentication_type.toLowerCase()}&code=${code}`
        );
        const JSONData = await response.json();
        console.log(
          "response fetched in async await",
          JSON.stringify(JSONData)
        );
        let email;
        let userName;
        if (authentication_type === AUTHENTICATION_TYPES.LINKEDIN) {
          email = JSONData.elements[0]["handle~"]["emailAddress"];
          userName =
            `${JSONData.localizedFirstName} ${JSONData.localizedLastName}`.trim();
        } else {
          email = JSONData.email;
          userName = JSONData.username;
        }

        if (JSONData.access_token) {
          localStorage.setItem("access_token", JSONData.access_token);
          localStorage.setItem("expires_in", JSONData.expires_in);
          localStorage.setItem("authentication_type", authentication_type);
          localStorage.setItem(
            "expires_at",
            JSONData.expires_in * 1000 + Date.now()
          );
          localStorage.setItem("email", email);
          localStorage.setItem("username", userName);
        }

        const domainUrl = window.location.origin;

        console.log("redirecting to submit job", fromPage);
        if (fromPage === "submitjob") {
          window.location.href =
            domainUrl + `/#/submit?jobNumber=${jobNumber}&fromPage=submitjob`;
        } else if (fromPage === "postjob") {
          window.location.href = domainUrl + `/#/postjob?fromPage=postjob`;
        } else {
          window.location.href = domainUrl + "/#" + queryString;
        }
      } catch (err) {}
    };

    // call api or anything
    let queryString = window.location.search;
    const url = window.location.href;
    const RqueryString = url.split("?");
    const appendString = "?" + RqueryString[1];
    const urlParams = new URLSearchParams(appendString);
    const code = urlParams.get("code");
    const state = urlParams.get("state");

    if (window.location.href.includes("code")) {
      console.log("has code and fetching access token");
      const [authentication_type, fromPage, jobNumber] = state.split(",") || [
        "",
        "",
        "",
      ];
      fetchAccessTokenAndRedirect({
        authentication_type,
        code,
        fromPage,
        jobNumber,
      });
    }
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Where Innovation Meets
            <span className="hero-title-accent"> AI-Powered Solutions</span>
          </h1>
          <p className="hero-subtitle">
            Building cutting-edge technology solutions with AI, Cloud, and Modern Development Practices.
            We bridge the gap between innovation and talent.
          </p>
          <div className="hero-cta">
            <Link to="/contact" className="btn btn-primary">
              Get Started
            </Link>
            <Link to="/about" className="btn btn-secondary">
              Learn More
            </Link>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-pattern"></div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">👥</div>
              <div className="stat-number">200+</div>
              <div className="stat-label">Technical Resources Placed</div>
              <div className="stat-description">
                AI/ML Engineers, Cloud Architects, Full-Stack Developers
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🚀</div>
              <div className="stat-number">20+</div>
              <div className="stat-label">Projects Delivered</div>
              <div className="stat-description">
                Cloud Migrations, AI Applications, Infrastructure Modernization
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">⏱️</div>
              <div className="stat-number">4 Weeks</div>
              <div className="stat-label">Average Time to Close</div>
              <div className="stat-description">
                Fast turnaround with high-quality talent
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">⭐</div>
              <div className="stat-number">5 Years</div>
              <div className="stat-label">of Excellence</div>
              <div className="stat-description">
                Trusted partner since 2019
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview Section */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive technology solutions powered by AI and modern practices
          </p>
          <div className="services-grid">
            <Link to="/development" className="service-card">
              <div className="service-icon">🤖</div>
              <h3 className="service-title">AI-Enhanced Development</h3>
              <p className="service-description">
                Leveraging Cursor, ChatGPT, and n8n for intelligent solutions that accelerate development and enhance infrastructure.
              </p>
              <span className="service-link">Learn More →</span>
            </Link>
            <Link to="/infra" className="service-card">
              <div className="service-icon">☁️</div>
              <h3 className="service-title">Cloud Infrastructure</h3>
              <p className="service-description">
                AWS, GCP, Azure with Terraform, Kubernetes, and GitOps for scalable, secure cloud environments.
              </p>
              <span className="service-link">Learn More →</span>
            </Link>
            <Link to="/mobile" className="service-card">
              <div className="service-icon">📱</div>
              <h3 className="service-title">Mobile Technology</h3>
              <p className="service-description">
                React Native apps with AI-powered backends, serverless architecture, and intelligent automation.
              </p>
              <span className="service-link">Learn More →</span>
            </Link>
            <Link to="/consulting" className="service-card">
              <div className="service-icon">💼</div>
              <h3 className="service-title">IT Consulting</h3>
              <p className="service-description">
                Strategic technology advisory, team building, and enterprise cloud solutions.
              </p>
              <span className="service-link">Learn More →</span>
            </Link>
          </div>
        </div>
      </section>

      {/* AI-Powered Approach Section */}
      <section className="ai-approach-section">
        <div className="container">
          <div className="ai-content">
            <div className="ai-text">
              <h2 className="section-title">Built with AI, Powered by Innovation</h2>
              <p className="section-subtitle">
                We integrate cutting-edge AI tools into every aspect of our development and infrastructure management
              </p>
              <div className="ai-features">
                <div className="ai-feature">
                  <div className="ai-feature-icon">⌨️</div>
                  <h3>AI-Enhanced Coding</h3>
                  <p>
                    Cursor for intelligent code completion, faster development cycles, and higher code quality.
                  </p>
                </div>
                <div className="ai-feature">
                  <div className="ai-feature-icon">🔄</div>
                  <h3>Intelligent Automation</h3>
                  <p>
                    n8n for workflow automation, seamless system integration, and reduced manual effort.
                  </p>
                </div>
                <div className="ai-feature">
                  <div className="ai-feature-icon">💬</div>
                  <h3>AI-Powered Support</h3>
                  <p>
                    ChatGPT integration for customer support, 24/7 intelligent assistance, and natural language processing.
                  </p>
                </div>
              </div>
            </div>
            <div className="ai-visual">
              <div className="ai-pattern"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Client Partnerships Section */}
      <section className="clients-section">
        <div className="container">
          <h2 className="section-title">Trusted by Industry Leaders</h2>
          <p className="section-subtitle">
            We partner with leading organizations to deliver exceptional results
          </p>
          <div className="clients-grid">
            <div className="client-card">
              <div className="client-logo">
                <img src={require("../images/hpe_pri_grn_pos_rgb.png")} alt="HPE" />
              </div>
              <h3 className="client-name">HPE GreenLakes</h3>
              <p className="client-achievement">100+ resources placed over 40 months</p>
              <p className="client-description">
                Building high-performing engineering teams for unified cloud interface development
              </p>
            </div>
            <div className="client-card">
              <div className="client-logo">
                <img src={require("../images/stem-logo.png")} alt="STEM" />
              </div>
              <h3 className="client-name">STEM</h3>
              <p className="client-achievement">Infrastructure as Code framework</p>
              <p className="client-description">
                Multi-region AWS cloud infrastructure with Terraform, Kubernetes, and GitOps
              </p>
            </div>
            <div className="client-card">
              <div className="client-logo">
                <img src={require("../images/missioncloud-black.png")} alt="MissionCloud" />
              </div>
              <h3 className="client-name">MissionCloud</h3>
              <p className="client-achievement">10+ projects delivered in 3 years</p>
              <p className="client-description">
                CI/CD pipelines, multi-region networks, app modernization, and cloud migrations
              </p>
            </div>
            <div className="client-card">
              <div className="client-logo">
                <img src={require("../images/haulr-logo.png")} alt="Haulr" />
              </div>
              <h3 className="client-name">Haulr</h3>
              <p className="client-achievement">Mobile marketplace solution</p>
              <p className="client-description">
                React Native app for construction and trucking industry with intelligent backend integration
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="container">
          <h2 className="section-title">Why Choose sariT͟Həm?</h2>
          <div className="why-choose-grid">
            <div className="why-choose-card">
              <div className="why-choose-icon">⚡</div>
              <h3>AI-Powered Efficiency</h3>
              <p>
                Faster delivery with AI tools, higher quality code, and cost-effective solutions that drive innovation.
              </p>
            </div>
            <div className="why-choose-card">
              <div className="why-choose-icon">🌍</div>
              <h3>Global Talent Network</h3>
              <p>
                200+ technical resources, 24/7 global team, and diverse expertise across AI, cloud, and modern development.
              </p>
            </div>
            <div className="why-choose-card">
              <div className="why-choose-icon">✅</div>
              <h3>Proven Track Record</h3>
              <p>
                20+ successful projects, trusted by enterprise clients, and 5 years of excellence in technology solutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call-to-Action Section */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">Ready to Transform Your Technology Stack?</h2>
          <p className="cta-subtitle">
            Let's discuss how AI-powered solutions can accelerate your business
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary btn-large">
              Schedule a Consultation
            </Link>
            <Link to="/development" className="btn btn-secondary btn-large">
              View Our Services
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

